import { v4 as uuidv4 } from 'uuid';

/** Correlation metadata embedded in a shadow desired document so a command
 *  can be traced app -> AWS IoT -> Home Assistant. */
export interface CommandMeta {
  cid: string;
  ts: number;
}

export const MQTT_TELEMETRY_WIDGET = 'mqtt';

export const CommandStage = {
  INITIATED: 'command_initiated',
  PUBLISH_ACKED: 'publish_acked',
  PUBLISH_NO_ACK: 'publish_no_ack',
  ACTUATION_CONFIRMED: 'actuation_confirmed',
} as const;

/** How long to wait for a QoS-1 PUBACK before emitting publish_no_ack (log-only). */
export const PUBLISH_ACK_WATCHDOG_MS = 5000;

export function newCommandMeta(): CommandMeta {
  return { cid: `cmd_${uuidv4()}`, ts: Date.now() };
}

export function readCid(message: any): string | undefined {
  return message?.state?.desired?._meta?.cid;
}

export function entityFromShadowTopic(topic: string): string | undefined {
  const segment = topic?.split('/')[5];
  return segment ? segment.replace('-', '.') : undefined;
}
